import React from "react";
import Cardkonfig from "../../dynamic components/Card";
import DetajetKompaniaCard from "./DetajetKompaniaCard";

function CardComponentInfoKomp() {
  return <Cardkonfig contentChild={<DetajetKompaniaCard />} width="100%" />;
}

export default CardComponentInfoKomp;
